<div class="radio-option">
  <div
    [class.radio-option__item-input--active]="isActiveSg()"
    class="radio-option__item-input"
  ></div>
  <span class="radio-option__label">{{ nameSg() }}</span>
  <ng-content></ng-content>
</div>
